import { APP_STORE_URL } from '@danda/shared';

interface AppStoreBadgeProps {
  className?: string;
}

/** Official "Download on the App Store" badge linking to the live Polymyth listing. */
export default function AppStoreBadge({ className = '' }: AppStoreBadgeProps) {
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download Polymyth on the App Store"
      className={`inline-block transition-opacity hover:opacity-80 ${className}`}
    >
      <img
        src="/download-on-the-app-store.svg"
        alt="Download on the App Store"
        className="h-12 w-auto"
      />
    </a>
  );
}
